/* src/app/shared/components/journey-progress-wheel/journey-progress-wheel.component.scss */
.journey-progress-wheel {
  display: grid;
  width: 100%;
  height: 100%;
}
.journey-progress-wheel-circle {
  grid-row: 1;
  grid-column: 1;
  width: inherit;
  height: inherit;
}
.journey-progress-wheel-icon {
  grid-row: 1;
  grid-column: 1;
  width: 40%;
  margin: auto;
}
/*# sourceMappingURL=journey-progress-wheel.component.css.map */
